// extracted by mini-css-extract-plugin
export default {"thumb":"transcript-templates-panel-content-module__thumb--OlNQ6"};